<template>
  <div class="stats-container">
    <label>message results</label>
    <div class="update-text">updates every 15 minutes, last updated {{statsUpdatedTime}}</div>

    <sb-table
      class="stats-table"
      :columns="columns"
      :rows="rows"
    ></sb-table>
  </div>
</template>

<script>
import { format } from 'date-fns'

export default {
  props: {
    extension: Object,
    hasAttachedMedia: Boolean,
    hasNotificationImgMeta: Boolean,
    notificationImage: Object,
    stats: Object,
  },

  name: 'Stats',

  data() {
    return {
      columns: [
        { label: 'recipients', key: 'recipients' },
        { label: 'clicks', key: 'clicks' },
        { label: 'visits', key: 'visits' },
        { label: 'visitor spend', key: 'visitor_spend' },
        { label: 'extension', key: 'extension' },
        { label: 'actions', key: 'actions' },
        { label: 'audio/mms', key: 'attachment' }
      ],
      rows: []
    }
  },

  created() {
    if (this.stats) this.configureStats()
  },

  computed: {
    statsUpdatedTime() {
      const statsUpdate = this.stats?.stats_at
      if (!statsUpdate) return '--'

      const updateTime = new Date(this.stats.stats_at)
      const updateUtcTime = new Date(updateTime.getTime() + updateTime.getTimezoneOffset()* 60000)
      return format(updateUtcTime, 'h:mmaaa')
    }
  },

  methods: {
    configureStats() {
      if (this.hasNotificationImgMeta) {
        this.columns.push({ label: 'notification image', key: 'notificationImg' })
      }

      const brokenDownStats = [{
        recipients: this.stats.sms_sent,
        clicks: this.getTextDisplay('clicks'),
        visits: this.getTextDisplay('visits_calculations', 'count_percentage'),
        visitor_spend: this.stats.visits_calculations.spend,
        extension: this.extension.name,
        actions: this.getTextDisplay('redemptions_rate_calculation'),
        attachment: this.hasAttachedMedia ? 'yes' : 'no',
        ...this.hasNotificationImgMeta && { notificationImg: !!this.notificationImage ? 'yes' : 'no' }
      }]

      this.rows = [...brokenDownStats]
    },

    getTextDisplay(statType, percentageKey = 'percentage') {
      let percentage = this.stats[statType][percentageKey]
      if (isNaN(percentage)) percentage = 0
      return `${this.stats[statType].count}(${percentage.toFixed(1)}%)`
    }
  }
}
</script>

<style lang="sass">
@import '../../assets/sass/colors'

.stats-container
  line-height: 1.5
  .update-text
    color: $negative-color
  .stats-table
    .grid-header
      font-weight: bold
</style>